/* CRUX complete-the-look — the cart-drawer attach moment (P1-7, operator
   GO 2026-07-27 "build all"). When anything is added to the bag, show the
   REST of the operator-curated look that product belongs to, right inside
   the drawer. Serves ONLY looks he created (/looks-for-product = curated,
   capped); nothing renders when a product belongs to no look.
   One fetch interceptor catches every add path — Dawn's product form,
   quick-adds, STL "+ add the look" — no per-surface wiring. Fail-silent
   throughout: a dead API just means no strip. */
(function () {
  'use strict';
  if (window.__cxCTL) return;
  window.__cxCTL = 1;

  var BASE = 'https://eondiscovery.co/api/storefront';
  var SHOP = (window.Shopify && window.Shopify.shop) || '';
  var lastAdded = null;              // {pid, t}
  var cache = {};                    // pid -> look payload (or null)

  // ── capture every add ──────────────────────────────────────
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (url.indexOf('/cart/add') > -1) {
      p.then(function (r) {
        try {
          r.clone().json().then(function (j) {
            var it = (j && j.items && j.items[0]) || j || {};
            var pid = it.product_id;
            if (pid) { lastAdded = { pid: String(pid), t: Date.now() }; sched(); }
          }).catch(function () {});
        } catch (e) {}
      }).catch(function () {});
    }
    return p;
  };

  function money(n) { return '₦' + Math.round(n).toLocaleString('en-NG'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function cdn(u, w) { if (!u) return u; return u.indexOf('?') > -1 ? u + '&width=' + w : u + '?width=' + w; }

  function lookFor(pid) {
    if (pid in cache) return Promise.resolve(cache[pid]);
    return origFetch(BASE + '/looks-for-product?shop=' + encodeURIComponent(SHOP) +
                     '&product_id=' + encodeURIComponent(pid), { mode: 'cors' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        cache[pid] = (d && d.ok && d.looks && d.looks[0]) || null;
        return cache[pid];
      })
      .catch(function () { return null; });
  }

  function cartProductIds() {
    return origFetch('/cart.js').then(function (r) { return r.json(); })
      .then(function (c) {
        return (c.items || []).map(function (i) { return String(i.product_id); });
      }).catch(function () { return []; });
  }

  var CSS = '.cx-ctl{padding:14px 16px;border-top:1px solid rgba(13,13,13,.12);font-family:"Helvetica Neue",Helvetica,Arial,sans-serif}' +
    '.cx-ctl__t{font-size:11px;font-weight:800;letter-spacing:.14em;margin:0 0 10px}' +
    '.cx-ctl__t em{font-style:normal;background:#FFE600;padding:2px 6px;margin-right:6px}' +
    '.cx-ctl__row{display:flex;gap:10px;overflow-x:auto;scrollbar-width:none}' +
    '.cx-ctl__row::-webkit-scrollbar{display:none}' +
    '.cx-ctl__it{flex:0 0 96px;text-decoration:none;color:inherit}' +
    '.cx-ctl__it img{display:block;width:96px;height:120px;object-fit:cover;background:#f0efe9}' +
    '.cx-ctl__n{display:block;font-size:10.5px;line-height:1.3;margin-top:5px;max-height:27px;overflow:hidden}' +
    '.cx-ctl__p{font-size:11px;font-weight:700}' +
    '.cx-ctl__add{display:block;width:100%;border:0;background:#FFE600;color:#0D0D0D;font-weight:800;font-size:10px;letter-spacing:.06em;padding:7px 0;margin-top:5px;cursor:pointer}';

  function ensureCss() {
    if (document.getElementById('cx-ctl-css')) return;
    var s = document.createElement('style');
    s.id = 'cx-ctl-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function host() {
    var d = document.querySelector('cart-drawer');
    if (!d) return null;
    // after the items list, before footer if present
    return d.querySelector('.drawer__contents') || d.querySelector('.drawer__inner') || d;
  }

  var scheduled = null;
  function sched() {
    if (scheduled) clearTimeout(scheduled);
    scheduled = setTimeout(render, 650);   // let the drawer re-render first
  }

  function render() {
    scheduled = null;
    if (!lastAdded || Date.now() - lastAdded.t > 60000) return;
    var h = host();
    if (!h) return;
    Promise.all([lookFor(lastAdded.pid), cartProductIds()]).then(function (rs) {
      var look = rs[0], inCart = rs[1];
      var old = document.getElementById('cx-ctl');
      if (!look) { if (old) old.remove(); return; }
      var rest = (look.pieces || []).filter(function (p) {
        return p.in_stock && p.variant_id &&
               String(p.shopify_id) !== lastAdded.pid &&
               inCart.indexOf(String(p.shopify_id)) === -1;
      }).slice(0, 6);
      if (old) old.remove();
      if (!rest.length) return;
      ensureCss();
      var box = document.createElement('div');
      box.className = 'cx-ctl';
      box.id = 'cx-ctl';
      box.innerHTML = '<p class="cx-ctl__t"><em>COMPLETE THE LOOK</em>styled with what you just added</p>' +
        '<div class="cx-ctl__row">' + rest.map(function (p) {
          return '<div class="cx-ctl__it">' +
            '<a href="/products/' + esc(p.handle || '') + '">' +
              '<img src="' + esc(cdn(p.image_url, 240)) + '" alt="' + esc(p.title || '') + '" loading="lazy">' +
              '<span class="cx-ctl__n">' + esc(p.title || '') + '</span>' +
              '<span class="cx-ctl__p">' + money(parseFloat(p.price) || 0) + '</span>' +
            '</a>' +
            '<button type="button" class="cx-ctl__add" data-ctl-add="' + esc(String(p.variant_id)) + '">+ ADD</button>' +
          '</div>';
        }).join('') + '</div>';
      h.appendChild(box);
      box.querySelectorAll('[data-ctl-add]').forEach(function (b) {
        b.addEventListener('click', function () {
          b.disabled = true; b.textContent = '…';
          window.fetch('/cart/add.js', { method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-ctl-add'), 10), quantity: 1 }] })
          }).then(function (r) { return r.ok ? r.json() : Promise.reject(0); })
            .then(function () {
              b.textContent = '✓';
              origFetch('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); })
                .then(function (sections) {
                  var d = document.querySelector('cart-drawer');
                  if (d && d.renderContents) d.renderContents({ sections: sections, id: 0 });
                }).catch(function () {});
            })
            .catch(function () { b.textContent = '+ ADD'; b.disabled = false; });
        });
      });
      if (window.EON && window.EON.track) window.EON.track('complete_look_shown', { pid: lastAdded.pid, items: rest.length });
    });
  }

  // drawer re-renders wipe injected DOM — watch and re-schedule
  var mo = new MutationObserver(function () {
    if (lastAdded && Date.now() - lastAdded.t < 60000 && !document.getElementById('cx-ctl')) sched();
  });
  function arm() {
    var d = document.querySelector('cart-drawer');
    if (d) mo.observe(d, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
  else arm();
})();
